function Error() {
  const windowParams = window?.params;
  const [status, error] = windowParams ? [windowParams.status, windowParams.error] : [404, 'Resource not found.'];
  return (
    <div>
      <div className="boxed-container boxed-container-large">
        <div className="margin-top-large">
          {status} {error}
        </div>
      </div>
    </div>
  );
}

export default Error;
